import { useEffect, useState } from 'react'
import { AulaPage } from '../pages/AulaPage'
import { AttendancePage } from '../pages/AttendancePage'
import { MasterPage } from '../pages/MasterPage'
import { Brand } from '../components/Brand'
import { TeacherAuthGate } from '../auth/TeacherAuthGate'

export function App() {
  const [path, setPath] = useState(window.location.pathname + window.location.search)
  useEffect(() => {
    const onPop = () => setPath(window.location.pathname + window.location.search)
    window.addEventListener('popstate', onPop)
    return () => window.removeEventListener('popstate', onPop)
  }, [])
  if (path.startsWith('/aula')) return <AulaPage />
  if (path.startsWith('/asistencia/')) return <AttendancePage token={decodeURIComponent(window.location.pathname.split('/')[2] || '')} />
  if (path.startsWith('/master')) return <TeacherAuthGate>{(authentication) => <MasterPage authentication={authentication} />}</TeacherAuthGate>
  return <main className="landing-page">
    <Brand />
    <div className="landing-copy"><p className="eyebrow">Universidad · QR dinámico</p><h1>Asistencia rápida.<br/>Control total.</h1><p>Una pantalla para el aula, un control para el profesor y un registro simple para cada alumno.</p></div>
    <div className="landing-actions"><a className="button" href="/master">Panel profesor</a><a className="button button--secondary" href="/aula">Pantalla de aula</a></div>
  </main>
}
